export default "__VITE_ASSET__Cb0zeHeW__"